import { useEffect } from 'react';

import { IPopupProps } from 'interfaces/Popup/popup';

import classes from './Popup.module.css';

export const Popup = (props: IPopupProps) => {
  const handleEscapePress = ({ keyCode }: any) => {
    if (keyCode === 27 && typeof props.closePopup === 'function')
      props.closePopup();
  };

  useEffect(() => {
    document.addEventListener('keydown', handleEscapePress);
    return () => {
      document.removeEventListener('keydown', handleEscapePress);
    };
  });

  return (
    <div
      style={{
        visibility: props.isOpen ? 'visible' : 'hidden',
        opacity: props.isOpen ? '1' : '0',
      }}
      className={`${classes.overlay}`}
    >
      <div
        className={`${classes.popup}`}
        style={{
          width: props.width,
          height: props.height ? props.height : 'auto',
          margin: props.margin,
        }}
      >
        {props.children}
      </div>
    </div>
  );
};
